import React from "react"

import ProjectIcon from '../../../../../../core/gd-ui/project-icon/project-icon-ui5'
import ProjectPathProperty from "../../../../../gd-ui/project-path/project-path-property";
import UI5CheckBox from "../../../../../gd-ui/checkbox/checkbox"

type Props = {
    option      : any
    isSelected? : boolean
    onClick     : callback
}

const debug = false
// const debug = "FieldTags_PopoverTagOption"

export default function FieldTags_PopoverTagOption(props: Props) {

    const onCheckboxClick = (e: React.MouseEvent) => {
        debug && console.log(debug, 'onCheckboxClick')
        e.stopPropagation()
        props.onClick &&  props.onClick(props.option, false)
    }

    const onClick = (e: React.MouseEvent) => {
        debug && console.log(debug, 'onClick')
        e.stopPropagation()
        props.onClick &&  props.onClick(props.option, true)
    }

    const project = gd.session.projects.get(props.option.value)!

    const classes = Classes("flex-row-left-center search-option w-100-percent h-36", {
        'is-selected': props.isSelected
    })

    return (
        <div className={classes} onClick={onClick}>
            <div className="flex-row-left-center flex-no-shrink p-r-15 h-100-percent" onClick={onCheckboxClick}>
                <UI5CheckBox size="14" isChecked={props.isSelected}/>
            </div>
            <ProjectIcon className  = "flex-no-shrink m-r-10"
                         projectId  = {project.id}
                         size       = "14"
                         hint       = {false}
                         colorize   = {true}/>
            <div className="label w-100-percent txt-truncate m-r-5">{project.name}</div>
            <ProjectPathProperty className          = "flex-no-shrink max-w-100 m-r-15"
                                 projectId          = {project.id}
                                 showEmptyRoot      = {false}
                                 maxFirstParents    = {1}
                                 showParentsOnly    = {true}/>
        </div>
    )
}